import {$dom} from '../../helpers/dom';
import noUiSlider from 'nouislider';
import {isElement, loop} from '../../helpers/_utilities';
import wNumb from 'wnumb';
import is from 'is_js';
import variables from '../../variables';
import {clearNum} from '../helpers';
import {$events} from '../../helpers/events';

const {
	exist,
	callAll,
	addClass,
	removeClass,
	get,
	attr
} = $dom;

export default function ranges(
	rootSelector = '.js-range',
	rangeSelector = '.js-range-input',
	fieldSelector = '.js-range-field',
	fieldFromSelector = '.js-range-field-from',
	fieldToSelector = '.js-range-field-to',
	fieldFromAttr = 'data-range-from',
	fieldToAttr = 'data-range-to'
) {

	if (exist([rootSelector, rangeSelector])) {

		let ranges = [];
		const
			{involved} = variables.classNames,
			numToThousand = wNumb({thousand: ' '})
		;

		function noUiSliderValues(input) {
			const
				isFromInput = is.not.null(attr(input, fieldFromAttr)),
				isToInput = is.not.null(attr(input, fieldToAttr))
			;
			let values = [];

			if (isFromInput) {
				values[0] = input.value;
				values[1] = null
			}

			if (isToInput) {
				values[0] = null;
				values[1] = input.value
			}

			return values
		}

		function handleNoUiSlider(values) {
			const
				from = clearNum(values[0]),
				to = clearNum(values[1]),
				rangeEl = this.target,
				root = rangeEl.closest(rootSelector),
				fieldsExist = exist(fieldFromSelector, root) && exist(fieldToSelector, root),
				min = clearNum(root.dataset.min),
				max = clearNum(root.dataset.max)
			;

			if (from !== min || to !== max) {
				addClass([root, rangeEl], involved)
			} else {
				removeClass([root, rangeEl], involved)
			}

			if (fieldsExist) {
				get(fieldFromSelector, root).value = numToThousand.to(from);
				get(fieldToSelector, root).value = numToThousand.to(to);
			}
		}

		function handleFields(event) {

			const
				input = event.target,
				rangeEl = get(rangeSelector, input.closest(rootSelector))
			;

			rangeEl.noUiSlider.set(noUiSliderValues(input));
		}

		function formatNumsOnInput(event) {

			const {target} = event;

			target.value = target.value.replace(/[^0-9]/g, '');

			if (target.value[0] === '0') target.value = target.value.substring(1);
			target.value = numToThousand.to(clearNum(target.value));
		}

		function emitRangeChange(values, handle, unencoded, tap, positions, noUiSlider) {

			const
				rootEl = noUiSlider.target.closest(rootSelector),
				boundInput = handle > 0 ? get(fieldToSelector, rootEl) : get(fieldFromSelector, rootEl)
			;

			if (isElement(boundInput)) {
				$events.emit(variables.customEventNames.rangeChanged, window, {
					boundInput,
					values,
					noUiSlider
				})
			}
		}

		const
			init = () => {

				callAll(rootSelector, root => {
					const rangeEl = get(rangeSelector, root);

					let {min, max, start, step, suffix} = root.dataset;

					min = clearNum(min);
					max = clearNum(max);
					start = start.split(',');
					step = clearNum(step);

					if (is.string(suffix)) suffix = ' '+suffix;

					ranges.push(noUiSlider.create(rangeEl, {
						start,
						step,
						connect: true,
						tooltips: false,
						range: {min,max},
						format: wNumb({
							decimals: 0,
							thousand: ' ',
							suffix
						})
					}));

					root.testFlag = false;

					rangeEl.noUiSlider.on('update', handleNoUiSlider);
					rangeEl.noUiSlider.on('set', emitRangeChange);

					const fieldsExist = exist(fieldFromSelector, root) && exist(fieldToSelector, root);
					if (fieldsExist) {
						const
							values = rangeEl.noUiSlider.get(),
							from = clearNum(values[0]),
							to = clearNum(values[1])
						;

						if (from === min) get(fieldFromSelector, root).value = '';
						if (to === max) get(fieldToSelector, root).value = '';
					}

				});

				$events.delegate
					.on('change', fieldSelector, handleFields)
					.on('input', fieldSelector, formatNumsOnInput)
				;

			},
			destroy = () => {
				loop(ranges, range => {
					range.target.noUiSlider.off('update', handleNoUiSlider);
					range.noUiSlider.off('set', emitRangeChange);
					range.destroy();
				});
				ranges = [];
				$events.delegate
					.off('change', fieldSelector, handleFields)
					.off('input', fieldSelector, formatNumsOnInput)
				;

			}
		;

		return {init, destroy}
	}

	return null
}
